import { bindable } from 'aurelia-framework';

export class AspectRatioBox {
    @bindable ratio = '1 1';
    @bindable follow = 'width';

    constructor() {}
}
